import { inject, Injectable } from '@angular/core';
import { QaroniIntermediate } from '@qaroni-core/types/qaroni-intermediate';
import { BehaviorSubject, shareReplay } from 'rxjs';
import { Origin } from '../types/origin';
import { OriginApiObject } from '../types/origin.response';
import { OriginHttpService } from './origin-http.service';

@Injectable({
  providedIn: 'root',
})
export class OriginService extends QaroniIntermediate {
  private originsSubject = new BehaviorSubject<Origin[]>([]);

  private http = inject(OriginHttpService);

  get origins$() {
    return this.originsSubject.asObservable().pipe(shareReplay(1));
  }

  public origins(): void {
    if (!(this.isAuth && this.storage.get())) {
      return;
    }

    this.http.origins$().subscribe({
      next: this.nextOrigins,
      error: this.errorOrigins,
    });
  }

  private nextOrigins = (response: OriginApiObject): void => {
    if (!response.result[0]) {
      return;
    }

    const origins = response.result;
    this.originsSubject.next(origins);
  };

  private errorOrigins = (): void => {
    this.originsSubject.next([]);
  };
}
